/**
 * Final-evaluation success screen.
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { VButton } from "form";
import SvgCup from "./SvgCup";

/**
 * Celebrates a passed final exam.
 */
const FinalSuccess = () => {
  const { t } = useTranslation("common");

  return (
    <>
      <div className="w-full">
        <div className="shadow mt-5 p-4 overflow-hidden position-relative">
          <div id="stars"></div>
          <div id="stars2"></div>
          <div id="stars3"></div>
          <div className="flex items-center flex-col w-full">
            <div className="w-36">
              <SvgCup />
            </div>
            <p className="font-bold fsp-22 ">{t("Congratulation ! You have successfully completed your training.")}</p>
            <p className="fsp-18 text-muted">{t("Your learning doesn't stop today!")}</p>

            <ul className="mt-2 text-left">
              <li>{t("Now is the time to apply your knowledge on a daily basis in your career")}</li>
              <li>{t("Do not hesitate to practice regularly by reconnecting to the platform")}</li>
              <li>
                {t("Download your certificate of achievement via the link below")}&nbsp;
                <Link to="/settings/document">{t("Download")}</Link>
              </li>
            </ul>

            <p className="text-base">{t("Just as Rome wasn't built in a day, keep learning!")}</p>

            <p className="font-bold fsp-22 ">{t("Bravo again and see you soon! 💪")}</p>

            <Link to={`/explore`} className="no-underline">
              <VButton style={{ height: "fit-content" }} onClick={() => {}} variant="contained">
                {t("Our other training courses")}
              </VButton>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default FinalSuccess;
